import React from "react";
import { motion } from "framer-motion";

// Fade-up + subtle scale reveal on scroll into view.
export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, scale: 0.98 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal. Pass an array of strings (lines).
export const MaskedLines = ({ lines, className = "", lineClassName = "", startDelay = 0.15 }) => {
  return (
    <span className={`block ${className}`} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1,
              delay: startDelay + i * 0.12,
              ease: [0.76, 0, 0.24, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export default Reveal;
